const P=a=>{const t=window.theme.locale.rootUrl==="/"?"":window.theme.locale.rootUrl;return`${window.location.origin}${t}/products/${a.handle}`},L=a=>a.toString().toLowerCase().replace(/[^a-z0-9]+/g,"-").replace(/-+/g,"-").replace(/^-|-$/g,""),z=(a,t)=>{const l=t.getTemplateOptions("product"),b=l.productPageUrl(a),m=t.getPrice?t.getPrice(a):a.price,$=t.getCompareAtPrice?t.getCompareAtPrice(a):a.compare_at_price,w=t.isProductOnSale($,m),v=a.images,g=v?v.length:0,y=a.featured_image||(v&&v.length>0?v[0]:null);let k="default";g>1&&(k=l.forceHoverGallery?"hover":"gallery");const C=()=>{var u,s,d;let n="";if(w&&(n+='<div class="product-card__badge badge body-extra-small">Sale<span>%</span></div>'),(d=(s=(u=a.metafields)==null?void 0:u.card)==null?void 0:s.badges)!=null&&d.value)for(const o of a.metafields.card.badges.value)n+=`<div class="product-card__badge badge body-extra-small">${o.name}</div>`;return n?`<div class="product-card__badges">${n}</div>`:""},p=()=>{var u,s,d;let n="";if(a.options_with_values){for(const o of a.options_with_values)if(o.name==="Size"){let c="";for(const r of o.values){const e=a.variants.find(f=>f.option1===r||f.option2===r||f.option3===r),i=e?e.available:!1;c+=`
              <div class="quick-add-form__variant">
                <input
                  type="radio"
                  id="${l.context||"card"}-${a.id}-option-${L(r)}"
                  name="Size"
                  value="${r}"
                  data-variant-id="${(e==null?void 0:e.id)||""}"
                  data-quantity="1"
                  class="quick-add-form__variant-input"
                  ${i?"":"disabled"}
                >
                <label
                  for="${l.context||"card"}-${a.id}-option-${L(r)}"
                  ${i?"":"disabled"}
                  class="quick-add-form__variant-label${i?"":" quick-add-form__variant-label--sold-out"}"
                >
                  <span>${r}</span>
                </label>
              </div>
            `}n+=`
            <div class="quick-add-form__variants-wrapper">
              <div class="quick-add-form__variants">
                ${l.showLabel?'<label for="Size" class="quick-add-form__label">Size</label>':""}
                ${c}
                <div class="quick-add-form__success visually-hidden" data-success>
                  <div class="quick-add-form__success-message" data-success-message>
                    Added to cart
                  </div>
                </div>
              </div>
            </div>
          `}else if(o.name==="Colour"||o.name==="Color"){let c="";for(let r=0;r<Math.min(o.values.length,3);r++){const e=o.values[r],i=a.variants.find(q=>q.option2===e),f=(s=(u=e.swatch)==null?void 0:u.color)==null?void 0:s.rgba,x=(d=e.swatch)==null?void 0:d.image;c+=`
                <input
                  type="radio"
                  id="${l.context||"card"}-${a.id}-color-${L(e)}"
                  name="Color"
                  value="${e}"
                  data-variant-id="${(i==null?void 0:i.id)||""}"
                  class="quick-add-form__variant-input visually-hidden"
                  ${e.selected?"checked":""}
                >
                <label
                  for="${l.context||"card"}-${a.id}-color-${L(e)}"
                  class="quick-add-form__variant-label--swatch${x?" quick-add-form__variant-label--swatch-image":""}"
                  data-product-url="${e.product_url||""}"
                  data-swatch
                  data-color="${L(e)}"
                  ${f||x?`style="${f?`background-color: rgba(${f}); --swatch-color: rgba(${f});`:""}${x?`background-image: url(${x});`:""}"`:`style="--swatch-color: var(--swatch-color-${L(e)});"`}
                >
                  <span class="visually-hidden">${e}</span>
                </label>
              `}o.values.length>3&&(c+=`
                <div class="quick-add-form__color-swatches-more">
                  <span>+${o.values.length-3}</span>
                </div>
              `),n+=`
              <div class="quick-add-form__color-swatches">
                ${l.showLabel?'<label for="Color" class="quick-add-form__label">Color</label>':""}
                ${c}
              </div>
            `}}return n},_=()=>w?`
        <span class="product-card__price--sale">${t.formatCurrency(m)}</span>
        <s class="product-card__price--compare">${t.formatCurrency($)}</s>
      `:`<span class="product-card__price--regular">${t.formatCurrency(m)}</span>`,h=()=>{if(k==="gallery"&&g>1){let n="";for(let u=0;u<Math.min(g,3);u++){const s=v[u];n+=`
          <a href="${b}" class="product-card__gallery-item" data-slide>
            <img src="${s.src}" alt="${a.title}" loading="lazy">
          </a>
        `}return`
        <div class="product-card__gallery" data-product-card-gallery>
          ${n}
          <div class="product-card__gallery-button product-card__gallery-button--prev" data-prev>
            <svg class="icon icon-chevron-left" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="product-card__gallery-button product-card__gallery-button--next" data-next>
            <svg class="icon icon-chevron-right" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 6L15 12L9 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="product-card__gallery-progress-bar" data-gallery-progress-bar>
            <span></span>
          </div>
        </div>
      `}else if(k==="hover"&&g>1){let n="";for(let u=0;u<Math.min(g,2);u++){const s=v[u];n+=`<img src="${s.src}" alt="${a.title}" loading="lazy">`}return`
        <a href="${b}" class="product-card__hover-gallery">
          ${n}
        </a>
      `}else return`
        <a class="product-card__default-image" href="${b}">
          ${y?`<img src="${y.src}" alt="${a.title}" loading="lazy">`:'<div class="placeholder-image"><p class="site-title">CDP</p></div>'}
        </a>
      `};return`
    <product-card
      data-product-card
      class="product-card"
      data-product-handle="${a.handle}"
      data-template-type="${l.forceHoverGallery&&g>1?"card-hover":"card"}"
    >
      <div class="product-card__media">
        ${C()}
        ${h()}
      </div>
      <div class="product-card__meta-wrapper">
        <div class="product-card__meta">
          <p class="product-card__title">${a.title.split(" - ")[0]}</p>
          <div class="product-card__price">
            ${_()}
          </div>
          <div class="product-card__quick-add-form">
            ${p()}
          </div>
          <button
            class="product-card__quick-add-button"
            type="button"
            data-quick-add-modal-toggle
            data-product-url="${a.url||b}"
          >
            <svg class="icon icon-bag" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8 7.5V5.5C8 3.567 9.567 2 11.5 2C13.433 2 15 3.567 15 5.5V7.5M3 7.5H20V20.5C20 21.328 19.328 22 18.5 22H4.5C3.672 22 3 21.328 3 20.5V7.5Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>
      </div>
    </product-card>
  `},M=a=>a.toString().toLowerCase().replace(/[^a-z0-9]+/g,"-").replace(/-+/g,"-").replace(/^-|-$/g,""),H=(a,t)=>{const l=t.getTemplateOptions("product"),b=l.productPageUrl(a),m=t.getPrice?t.getPrice(a):a.price,$=t.getCompareAtPrice?t.getCompareAtPrice(a):a.compare_at_price,w=$>m,v=a.images,g=v?v.length:0,y=window.theme.productCard.maxSlides,k=g<y?g:y;let C="gallery";g<=1&&(C="default"),g===0&&(C="empty"),l.forceHoverGallery&&(C="hover");const p=()=>{let d="";if(a.options_with_values){for(const o of a.options_with_values)if(o.name==="Size"){let c="";for(const r of o.values){const e=(r==null?void 0:r.name)||r,i=a.variants.find(x=>x.option1===e||x.option2===e||x.option3===e),f=i?i.available:!1;c+=`
              <div class="quick-add-form__variant">
                <input
                  type="radio"
                  id="${l.context||"card"}-${a.id}-option-${M(e)}"
                  name="Size"
                  value="${e}"
                  data-variant-id="${(i==null?void 0:i.id)||""}"
                  data-quantity="1"
                  class="quick-add-form__variant-input"
                  ${f?"":"disabled"}
                >
                <label
                  for="${l.context||"card"}-${a.id}-option-${M(e)}"
                  ${f?"":"disabled"}
                  class="quick-add-form__variant-label${f?"":" quick-add-form__variant-label--sold-out"}"
                >
                  <span>${e}</span>
                </label>
              </div>
            `}d+=`
            <div class="quick-add-form__variants-wrapper">
              <div class="quick-add-form__variants">
                ${l.showLabel?'<label for="Size" class="quick-add-form__label">Size</label>':""}
                ${c}
                <div class="quick-add-form__success visually-hidden" data-success>
                  <div class="quick-add-form__success-message" data-success-message>
                    Added to cart
                  </div>
                </div>
              </div>
            </div>
          `}}return`
      <div class="quick-add-form__variant-options">
        ${d}
      </div>
    `},_=()=>{const d=a.tags||[],o=d.some(e=>e.includes("badge:"));if(!(w||o))return"";let r="";if(w)r=`
        <div class="product-card__badge badge product-card__badge--sale">
          Save <span>${Math.round(($-m)*100/$)}%</span>
        </div>
      `;else{let e=!1;if(!e){for(const i of d)if(i.includes("badge:use-code-")){r=`<div class="product-card__badge badge product-card__badge--use-code">Use Code ${i.replace("badge:use-code-","").replace(/-/g," ").toUpperCase()}</div>`,e=!0;break}}if(!e&&d.includes("badge:trending")&&(r='<div class="product-card__badge badge product-card__badge--trending">Trending</div>',e=!0),!e&&d.includes("badge:low-in-stock")&&(r='<div class="product-card__badge badge product-card__badge--low-stock">Low in Stock</div>',e=!0),!e){for(const i of d)if(i.includes("badge:custom-")){r=`<div class="product-card__badge badge product-card__badge--custom">${i.replace("badge:custom-","").replace(/-/g," ").toUpperCase()}</div>`,e=!0;break}}!e&&d.includes("badge:coming-soon")&&(r='<div class="product-card__badge badge product-card__badge--coming-soon">Coming Soon</div>',e=!0),!e&&d.includes("badge:sold-out")&&(r='<div class="product-card__badge badge product-card__badge--sold-out">Sold Out</div>',e=!0),!e&&d.includes("badge:pre-order")&&(r='<div class="product-card__badge badge product-card__badge--pre-order">Pre-order</div>',e=!0),!e&&d.includes("badge:most-loved")&&(r='<div class="product-card__badge badge product-card__badge--most-loved">Most Loved</div>',e=!0),!e&&d.includes("badge:best-seller")&&(r='<div class="product-card__badge badge product-card__badge--best-seller">Best Seller</div>',e=!0),!e&&d.includes("badge:new")&&(r='<div class="product-card__badge badge product-card__badge--new">New</div>',e=!0)}return r?`<div class="product-card__badges">${r}</div>`:""},h=()=>$>m?`
        <span class="product-card__price--sale">${t.formatCurrency(m)}</span>
        <s class="product-card__price--compare">${t.formatCurrency($)}</s>
      `:`<span class="product-card__price--regular">${t.formatCurrency(m)}</span>`,n=()=>{if(C==="gallery"&&g>1){let d="";for(let o=0;o<Math.min(g,y);o++){const c=v[o];d+=`
          <a href="${b}" class="product-card__gallery-item" data-slide>
            <img src="${c.src}" alt="${a.title}" loading="lazy">
          </a>
        `}return`
        <div class="product-card__gallery" data-product-card-gallery>
          ${d}
          <div class="product-card__gallery-button product-card__gallery-button--prev" data-prev>
            <svg class="icon icon-chevron-left" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="product-card__gallery-button product-card__gallery-button--next" data-next>
            <svg class="icon icon-chevron-right" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 6L15 12L9 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="product-card__gallery-pagination body-small" data-pagination>
            <span>1</span><span>/</span><span>${k}</span>
          </div>
        </div>
      `}else if(C==="hover"&&g>1){let d="";for(let o=0;o<Math.min(g,2);o++){const c=v[o];d+=`<img src="${c.src}" alt="${a.title}" loading="lazy">`}return`
        <a href="${b}" class="product-card__hover-gallery">
          ${d}
        </a>
      `}else if(C==="default"){const d=a.featured_image;return`
        <a class="product-card__default-image" href="${b}">
          ${d?`<img src="${d.src}" alt="${a.title}" loading="lazy">`:""}
        </a>
      `}else return'<div class="product-card__gallery-item-image placeholder-svg"></div>'},u=()=>{var o,c,r;return`
      <div class="product-card__meta">
        ${(r=(c=(o=a.metafields)==null?void 0:o.card)==null?void 0:c.badges)!=null&&r.value?`
      <div class="product-card__badges--mobile">
        ${_()}
      </div>
    `:""}
        <p class="product-card__title">${a.title.split(" - ")[0]}</p>
        <div class="product-card__price">
          ${h()}
        </div>
        <div class="product-card__form-wrapper">
          <div class="product-card__quick-add-form">
            ${p()}
          </div>
        </div>
      </div>
    `};return`
    <product-card
      data-product-card
      class="product-card"
      data-template-type="card"
      data-product-handle="${a.handle}"
    >
      <div class="product-card__media">
        ${_()}
        ${n()}
        <button
          class="product-card__quick-add-button"
          type="button"
          data-quick-add-modal-toggle
          data-product-url="${a.url||b}"
        >
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 6H17L16.165 15.181C16.1198 15.6779 15.8906 16.14 15.5222 16.4766C15.1538 16.8131 14.673 16.9998 14.174 17H3.826C3.32704 16.9998 2.84617 16.8131 2.4778 16.4766C2.10942 16.14 1.88016 15.6779 1.835 15.181L1 6Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>
        <path d="M5 8V5C5 3.93913 5.42143 2.92172 6.17157 2.17157C6.92172 1.42143 7.93913 1 9 1C10.0609 1 11.0783 1.42143 11.8284 2.17157C12.5786 2.92172 13 3.93913 13 5V8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
        </button>
      </div>
      ${u()}
    </product-card>
  `},S=a=>a.toString().toLowerCase().replace(/[^a-z0-9]+/g,"-").replace(/-+/g,"-").replace(/^-|-$/g,""),B=(a,t)=>{const l=t.getTemplateOptions("product"),b=l.productPageUrl(a),m=t.getPrice?t.getPrice(a):a.price,$=t.getCompareAtPrice?t.getCompareAtPrice(a):a.compare_at_price,w=$>m,v=a.images,g=v?v.length:0,y=3;let k="hover";g<=1&&(k="default"),l.forceGallery&&(k="gallery");const C=()=>{let s="";if(a.options_with_values){for(const d of a.options_with_values)if(d.name==="Size"){let o="";const c=new Set(d.values.map(e=>(e==null?void 0:e.name)||e)),r=new Set;for(const e of a.variants){const i=[e.option1,e.option2,e.option3].find(x=>c.has(x));if(!i||r.has(i))continue;r.add(i);const f=e.available;o+=`
              <div class="quick-add-form__variant">
                <input
                  type="radio"
                  id="${l.context||"card"}-${a.id}-option-${S(i)}"
                  name="Size"
                  value="${i}"
                  data-variant-id="${e.id}"
                  data-quantity="1"
                  class="quick-add-form__variant-input"
                  ${f?"":"disabled"}
                >
                <label
                  for="${l.context||"card"}-${a.id}-option-${S(i)}"
                  ${f?"":"disabled"}
                  class="quick-add-form__variant-label${f?"":" quick-add-form__variant-label--sold-out"}"
                >
                  <span>${i}</span>
                  <svg aria-label="Tick icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_1198_25368)">
                  <path d="M6.90909 11L6.55874 11.3567C6.75324 11.5478 7.06494 11.5478 7.25945 11.3567L6.90909 11ZM14.5 8C14.5 11.5899 11.5899 14.5 8 14.5V15.5C12.1421 15.5 15.5 12.1421 15.5 8H14.5ZM8 14.5C4.41015 14.5 1.5 11.5899 1.5 8H0.5C0.5 12.1421 3.85786 15.5 8 15.5V14.5ZM1.5 8C1.5 4.41015 4.41015 1.5 8 1.5V0.5C3.85786 0.5 0.5 3.85786 0.5 8H1.5ZM8 1.5C11.5899 1.5 14.5 4.41015 14.5 8H15.5C15.5 3.85786 12.1421 0.5 8 0.5V1.5ZM3.64965 8.49958L6.55874 11.3567L7.25945 10.6433L4.35035 7.78613L3.64965 8.49958ZM7.25945 11.3567L12.3504 6.35672L11.6496 5.64328L6.55874 10.6433L7.25945 11.3567Z" fill="currentColor" />
                  </g>
                  <defs>
                  <clipPath id="clip0_1198_25368">
                  <rect width="16" height="16" fill="white"/>
                  </clipPath>
                  </defs>
                  </svg>
                </label>
              </div>
            `}s+=`
            <div class="quick-add-form__variants-wrapper">
              <div class="quick-add-form__variants">
                ${l.showLabel?'<label for="Size" class="quick-add-form__label">Size</label>':""}
                ${o}
                <div class="quick-add-form__success visually-hidden" data-success>
                  <div class="quick-add-form__success-message" data-success-message>
                    Added to cart
                  </div>
                </div>
              </div>
            </div>
          `}}return s},p=()=>{const s=a.tags||[],d=s.some(r=>r.includes("badge:"));if(!(w||d))return"";let c="";if(w)c=`
        <div class="product-card__badge badge product-card__badge--sale">
          Save <span>${Math.round(($-m)*100/$)}%</span>
        </div>
      `;else{let r=!1;if(!r){for(const e of s)if(e.includes("badge:use-code-")){c=`<div class="product-card__badge badge product-card__badge--use-code">Use Code ${e.replace("badge:use-code-","").replace(/-/g," ").toUpperCase()}</div>`,r=!0;break}}if(!r&&s.includes("badge:trending")&&(c='<div class="product-card__badge badge product-card__badge--trending">Trending</div>',r=!0),!r&&s.includes("badge:low-in-stock")&&(c='<div class="product-card__badge badge product-card__badge--low-stock">Low in Stock</div>',r=!0),!r){for(const e of s)if(e.includes("badge:custom-")){c=`<div class="product-card__badge badge product-card__badge--custom">${e.replace("badge:custom-","").replace(/-/g," ").toUpperCase()}</div>`,r=!0;break}}!r&&s.includes("badge:coming-soon")&&(c='<div class="product-card__badge badge product-card__badge--coming-soon">Coming Soon</div>',r=!0),!r&&s.includes("badge:sold-out")&&(c='<div class="product-card__badge badge product-card__badge--sold-out">Sold Out</div>',r=!0),!r&&s.includes("badge:pre-order")&&(c='<div class="product-card__badge badge product-card__badge--pre-order">Pre-order</div>',r=!0),!r&&s.includes("badge:most-loved")&&(c='<div class="product-card__badge badge product-card__badge--most-loved">Most Loved</div>',r=!0),!r&&s.includes("badge:best-seller")&&(c='<div class="product-card__badge badge product-card__badge--best-seller">Best Seller</div>',r=!0),!r&&s.includes("badge:new")&&(c='<div class="product-card__badge badge product-card__badge--new">New</div>',r=!0)}return c?`<div class="product-card__badges">${c}</div>`:""},_=()=>`
      <div class="product-card__price-wrapper">
        ${w?`<s class="product-card__price--compare">${t.formatCurrency($)}</s>`:""}
        <span class="product-card__price--${w?"sale":"regular"}">${t.formatCurrency(m)}</span>
      </div>
    `,h=()=>{if(k==="gallery"&&g>1){let s="";for(let d=0;d<Math.min(g,y);d++){const o=v[d];s+=`
          <a href="${b}" class="product-card__gallery-item" data-slide>
            <img src="${o.src}" alt="${a.title}" loading="lazy">
          </a>
        `}return`
        <div class="product-card__gallery" data-product-card-gallery>
          ${s}
          <div class="product-card__gallery-button product-card__gallery-button--prev" data-prev>
            <svg class="icon icon-chevron-left" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="product-card__gallery-button product-card__gallery-button--next" data-next>
            <svg class="icon icon-chevron-right" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 6L15 12L9 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="product-card__gallery-progress-bar" data-gallery-progress-bar>
            <span></span>
          </div>
        </div>
      `}else if(k==="hover"&&g>1){let s="";for(let d=0;d<Math.min(g,2);d++){const o=v[d];s+=`<img src="${o.src}" alt="${a.title}" loading="lazy">`}return`
        <a href="${b}" class="product-card__hover-gallery">
          ${s}
        </a>
      `}else{const s=a.featured_image;return`
        <a class="product-card__default-image" href="${b}">
          ${s?`<img src="${s.src}" alt="${a.title}" loading="lazy" placeholder="product">`:'<div class="product-card__placeholder placeholder-svg"></div>'}
        </a>
      `}},n=()=>`
      <button class="product-card__wishlist-button product-card__cta" type="button">
        <svg class="icon icon-heart" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20.84 4.61C20.3292 4.099 19.7228 3.69364 19.0554 3.41708C18.3879 3.14052 17.6725 2.99817 16.95 2.99817C16.2275 2.99817 15.5121 3.14052 14.8446 3.41708C14.1772 3.69364 13.5708 4.099 13.06 4.61L12 5.67L10.94 4.61C9.9083 3.5783 8.50903 2.9987 7.05 2.9987C5.59096 2.9987 4.19169 3.5783 3.16 4.61C2.1283 5.6417 1.5487 7.04097 1.5487 8.5C1.5487 9.95903 2.1283 11.3583 3.16 12.39L4.22 13.45L12 21.23L19.78 13.45L20.84 12.39C21.351 11.8792 21.7563 11.2728 22.0329 10.6053C22.3095 9.93789 22.4518 9.22248 22.4518 8.5C22.4518 7.77752 22.3095 7.06211 22.0329 6.39467C21.7563 5.72723 21.351 5.1208 20.84 4.61V4.61Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    `,u=()=>{const s=`
      <div class="product-card__badges-mobile">
        ${p()}
      </div>
    `;return`
      <div class="product-card__meta">
        <p class="product-card__title">${a.title.charAt(0).toUpperCase()+a.title.slice(1).toLowerCase().split(" - ")[0]}</p>
        <div class="product-card__price">
          ${_()}
        </div>
        ${s}
      </div>
    `};return`
    <product-card
      data-product-card
      class="product-card"
      data-template-type="card"
      data-product-handle="${a.handle}"
    >
      <div class="product-card__media">
        ${p()}
        ${n()}
        ${h()}
        <div class="product-card__ctas">
          <button
            class="product-card__quick-add-button product-card__cta"
            type="button"
            data-quick-add-modal-toggle
            data-product-url="${a.url||b}"
          >
            <svg class="icon icon-plus" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 5V19M5 12H19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
          ${n()}
        </div>
        <div class="product-card__quick-add-form">
          ${C()}
        </div>
      </div>
      ${u()}
    </product-card>
  `},T=(a,t)=>{var m;const l=((m=window.theme)==null?void 0:m.brandEnvironment)||"cdp";switch(l==="gia"?"iamgia":l){case"iamgia":return H(a,t);case"tigermist":return B(a,t);case"cdp":default:return z(a,t)}},A=(a,t)=>{var v,g,y,k,C;const l=((v=t==null?void 0:t.dataset)==null?void 0:v.sectionId)||"no-results",b=(g=t==null?void 0:t.dataset)==null?void 0:g.title,m=(y=t==null?void 0:t.dataset)==null?void 0:y.headingSize,$=(k=t==null?void 0:t.dataset)==null?void 0:k.buttonLabel,w=(C=t==null?void 0:t.dataset)==null?void 0:C.buttonUrl;return{widget:{options:{limit:a,displayFormat:"grid",includeTagalysCSS:!1},render:(p,_)=>{const h=_.props,u=h.helpers.getProducts();if(h.loading===!1)return u.length===0?null:p`
            <${_.templates.title} />
            <${_.templates.productList} />
            <${_.templates.button} />
          `}},title:{render:p=>b?p`
            <div class="product-recommendations__title">
              <h2 class="title inline-richtext ${m}">${b}</h2>
            </div>
          `:p``},productList:{render:(p,_)=>p`
        <slider-component class="slider-component-full-width">
          <${_.templates.products} />
        </slider-component>
      `},products:{render:(p,_)=>{const n=_.props.helpers.getProducts();return p`<ul
          id="Slider-${l}"
          class="results-grid results-grid--default list-inline m-results-grid--2"
        >
          ${n.map((u,s)=>p`<li class="results-grid__tile">
                <${_.templates.product} key=${s} product=${u} />
              </li>`)}
        </ul> `}},product:{options:{productPageUrl(p){return P(p)}},render:(p,_)=>{const h=_.props,n=h.product,u=h.helpers;return p`<div
          class="tagalys-section__slide"
          id="Slide-${n.id}"
          dangerouslySetInnerHTML=${{__html:T(n,u)}}
        />`}},carouselActions:{render:p=>{var _,h,n,u,s,d;return p`
        <div class="slider-buttons">
          <button
            type="button"
            class="slider-button slider-button--prev"
            name="previous"
            aria-label="${(n=(h=(_=window.theme)==null?void 0:_.strings)==null?void 0:h.accessibility)==null?void 0:n.previousSlide}"
            aria-controls="Slider-${l}"
          >
            <span class="svg-wrapper">
              <svg
                class="icon icon--arrow-right"
                aria-label="Icon arrow right"
                width="8"
                height="9"
                viewBox="0 0 8 9"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M0 4.43945H7" stroke="currentColor"></path>
                <path d="M3.28711 0.787109L7.00015 4.50015L3.28711 8.2132" stroke="currentColor"></path>
              </svg>
            </span>
          </button>
          <button
            type="button"
            class="slider-button slider-button--next"
            name="next"
            aria-label="${(d=(s=(u=window.theme)==null?void 0:u.strings)==null?void 0:s.accessibility)==null?void 0:d.nextSlide}"
            aria-controls="Slider-${l}"
          >
            <span class="svg-wrapper">
              <svg
                class="icon icon--arrow-right"
                aria-label="Icon arrow right"
                width="8"
                height="9"
                viewBox="0 0 8 9"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M0 4.43945H7" stroke="currentColor"></path>
                <path d="M3.28711 0.787109L7.00015 4.50015L3.28711 8.2132" stroke="currentColor"></path>
              </svg>
            </span>
          </button>
        </div>
      `}},button:{render:p=>$&&w?p`
            <div class="product-recommendations__button">
              <a href="${w}" class="button button--secondary">${$}</a>
            </div>
          `:p``}}};export{P as c,T as r,A as t};
